module.exports = __webpack_public_path__ + "images/emoji/grin.e7ceafccee100a22ed01.png";